import React, { Component } from 'react';

import {
    Container,
    Row,
    Col,
    FormGroup, Label, Input,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';



import ListBuilder from './listBuilder';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../helpers/linkHelper';
import { API_ENDPOINT, GOOGLE_API_KEY } from '../constants';
import moment from 'moment';
import eRemissIcon from '../assets/svg/e.svg';

import Isvg from 'react-inlinesvg';
import Checkbox from './forms/fields/checkbox';

import garabage from '../assets/svg/garbage.svg'


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}




const loadDataWithQuery = [
    (fetchFunction, lang, match, query) => {

        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        return fetchFunction(API_ENDPOINT + '/data/deletion-logs', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: query.page,
                entries: query.entries,
                filter: query.filter,
                sortType: query.sortType,
                sortField: query.sortField,
                group: query.group,
                query: queryFields
            })
        }).then(parseJSON).then(({ result, status }) => {
            if (status >= 200 && status < 300)
                return {
                    page: query.page ? query.page : 0,
                    items: result.items,
                    total: result.total,
                    resultFilter: result.filter
                }
        })


    },

]

/**
* List of patients for selected clinic and selected department
* @author   Milan Stanojevic
*/
class DeletionLogsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            regions: [],
            cities: [],
            groups: [],
            subgroups: [],
            ...props.initialData,
            useState: true,
            params: {
                entries: 10,
                page: 0,
            },
            items: [],
            total: 0,
            loading: true,
            suggestions: [],

        };
    }


    get = () => {
        let params = this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic });
        params.group = this.props.selectedGroup;
        params.clinic = this.props.selectedClinic;
        params._ts = new Date().getTime();

        this.setState({
            _ts: params._ts
        }, () => {
            for (let i = 0; i < loadDataWithQuery.length; i++) {
                loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, params).then((data) => {

                    this.setState({
                        ...data,
                        loading: null
                    })
                })
            }

        })


    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();

        let params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 });


    }

    componentWillUnmount() {
    }



    componentDidUpdate(prevProps, prevState) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })

        }

        if (this.state.useState && prevState._useStateTs != this.state._useStateTs) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })

        }
        if (prevProps.selectedGroup != this.props.selectedGroup) {
            this.get();
        }

        // if (prevProps.getLogs != this.props.getLogs) {
        //     this.get();
        // }


    }


    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field == 'waitingTime' ? 'waitingMin' : field;
            state.sortType = type;
            this.setState({
                params: state
            })

            this.setState({
                _useStateTs: new Date().getTime()
            })

        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field == 'waitingTime' ? 'waitingMin' : field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };

                obj[name] = value;

                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;


                this.setState({ params: obj })
            }

            this.setState({
                _useStateTs: new Date().getTime()
            })
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }

    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {

                    obj[fields[i].name] = fields[i].value;

                }
                this.setState({ params: obj })
            }

            this.setState({
                _useStateTs: new Date().getTime()
            })

        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }









    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }

        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const patientInfoSettings = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].patientInfoSettings;


        return (
            <div className="users-filter">

                <ListBuilder
                    lang={this.props.lang}
                    loading={this.state.loading}
                    total={this.state.total}
                    showNumeration={false}
                    fields={
                        patientInfoSettings?.isCustomIdEnabled ?
                            [
                                { type: 'text', name: 'name', label: 'Patient'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'socialSecurityNumber', label: 'Social security number'.translate(this.props.lang), allowSort: true },
                                // { type: 'text', name: 'dateOfBirth', label: 'Date of birth'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'customId', label: patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'requestDate', label: 'Request date'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'deletionDate', label: 'Deletion date'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'reason', label: 'Reason for deletion'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'createdByUsername', label: 'Deleted by'.translate(this.props.lang), allowSort: true },

                            ]
                            :
                            [
                                { type: 'text', name: 'name', label: 'Patient'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'socialSecurityNumber', label: 'Social security number'.translate(this.props.lang), allowSort: true },
                                // { type: 'text', name: 'dateOfBirth', label: 'Date of birth'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'requestDate', label: 'Request date'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'deletionDate', label: 'Deletion date'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'reason', label: 'Reason for deletion'.translate(this.props.lang), allowSort: true },
                                { type: 'text', name: 'createdByUsername', label: 'Deleted by'.translate(this.props.lang), allowSort: true },

                            ]
                    }
                    items={this.state.items.map(item => {
                        return {
                            ...item,
                            customId: item?.deletionRequest?.customId?.[this.props.selectedGroup] ? item.deletionRequest.customId[this.props.selectedGroup] : '',
                            dateOfBirth: item?.deletionRequest?.dateOfBirth?.date,
                            socialSecurityNumber: item?.deletionRequest?.socialSecurityNumber ? item.deletionRequest.socialSecurityNumber : null,
                            requestDate: item.requestDate && item.requestDate !== 'N/A' ? this.props.getStringDateTs(item.requestDate, this.props.dateFormat + ' HH:mm')/*moment.unix(item.requestDate).format(this.props.dateFormat  + ' HH:mm')*/ : "N/A",
                            deletionDate: item.deletionDate ? this.props.getStringDateTs(item.deletionDate, this.props.dateFormat + ' HH:mm')/*moment.unix(item.deletionDate).format(this.props.dateFormat  + ' HH:mm')*/ : null,
                            socialSecurityNumber: item.deletionRequest && item.deletionRequest.socialSecurityNumber ? item.deletionRequest.socialSecurityNumber : null,
                            name: item.deletionRequest && item.deletionRequest.name ? item.deletionRequest.name : null,
                            reason: item.deletionRequest && item.deletionRequest.reason ? item.deletionRequest.reason : null,
                            createdByUsername: item?.createdByUsername ?? 'system',

                        }
                    })}

                    rawItems={this.state.items}
                    params={params}
                    sortField={params.sortField}
                    sortType={params.sortType}
                    updateSort={this.updateSort}
                    updateParams={this.updateParams}
                    updateMultipleParams={this.updateMultipleParams}
                ></ListBuilder>







            </div >
        );


    }
}
export default DeletionLogsComponent;